
import ApiService from "@/common/ApiService";
import urlConfig from "@/../public/urlConfig.json";
import vue from "vue";
const api = new ApiService(vue.prototype.$config.flightBaseAddress);

export default {

    state: {
        oneWaySelected: {},
        twoWaySelected: {},
        passengerDetails: {},
    },
    mutations: {
        SetOneWayFlightSelected(state, oneWaySelected) {
            state.oneWaySelected = oneWaySelected;
        },

        SetTwoWayFlightSelected(state, twoWaySelected) {
            state.twoWaySelected = twoWaySelected;
        },
        SetePassengerDetails(state, passengerDetails) {
            state.passengerDetails = passengerDetails;
        }
    },

    getters: {
        GetOneWayFlightSelected(state) {
            return state.oneWaySelected
        },
        GetTwoWayFlightSelected(state) {
            return state.twoWaySelected
        },
        GetPassengerDetail(state) {
            return state.passengerDetails
        },
    },

    actions: {
        async getOneWayAvailableFlights(context, data) {

            try {
                const response = await api.Post("/FlightEngine/GetAvailableFlights", data);

                return (response.data);
            } catch (err) {
                console.log(err);
            }
        },
        async getTwoWayAvailableFlights(context, data) {

            try {
                const response = await api.Post("/FlightEngine/GetTwoWayAvailableFlights", data);

                return (response.data);
            } catch (err) {
                console.log(err);
            }
        },

        async reserveFlight(context, data) {
            try {
                const response = await api.Post("/FlightEngine/ReserveFlight", data);

                return (response.data);
            } catch (err) {
                console.log(err);
            }
        },
        storeOneWaySelectedFlight(context, data) {
            context.commit("SetOneWayFlightSelected", data);
        },
        storeTwoWaySelectedFlight(context, data) {
            context.commit("SetTwoWayFlightSelected", data);
        },
        storePassengerDetails(context, data) {
            context.commit("SetePassengerDetails", data);
        },
    }
}